module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_9006.f2b335a8.png";